import { render } from "./InputPage.vue?vue&type=template&id=d2a86d98&scoped=true"
import script from "./InputPage.vue?vue&type=script&lang=js"
export * from "./InputPage.vue?vue&type=script&lang=js"

import "./InputPage.vue?vue&type=style&index=0&id=d2a86d98&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2a86d98"]])

export default __exports__